import { downloadBlob } from "./downloadFile";

export function openInspectorReportWindow() {
  const reportWindow = window.open("", "_blank");
  if (!reportWindow) return null;

  reportWindow.document.write(`<!doctype html>
    <html>
      <head>
        <title>Preparing inspector report</title>
        <style>
          body {
            margin: 0;
            min-height: 100vh;
            display: grid;
            place-items: center;
            background: #f8fafc;
            color: #111827;
            font-family: Arial, sans-serif;
          }
          .report-loading { text-align: center; padding: 24px; }
          .spinner {
            width: 38px;
            height: 38px;
            margin: 0 auto 18px;
            border: 4px solid #d1fae5;
            border-top-color: #059669;
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
          }
          h1 { margin: 0 0 8px; font-size: 22px; }
          p { margin: 0; color: #4b5563; font-size: 15px; }
          @keyframes spin { to { transform: rotate(360deg); } }
        </style>
      </head>
      <body>
        <main class="report-loading">
          <div class="spinner" aria-hidden="true"></div>
          <h1>Preparing inspector report…</h1>
          <p>The PDF will appear here when it is ready.</p>
        </main>
      </body>
    </html>`);
  reportWindow.document.close();

  return reportWindow;
}

export function showInspectorPdf(reportWindow, data, lookup) {
  const safeLookup = safeReportLookup(lookup);
  const pdfBlob = new Blob([data], { type: "application/pdf" });
  const pdfUrl = window.URL.createObjectURL(pdfBlob);

  if (reportWindow) {
    reportWindow.location.replace(pdfUrl);
    window.setTimeout(() => window.URL.revokeObjectURL(pdfUrl), 60000);
    return;
  }

  downloadBlob(data, `traceability-${safeLookup}.pdf`, "application/pdf");
  window.URL.revokeObjectURL(pdfUrl);
}

export function downloadInspectorExcel(data, lookup) {
  downloadBlob(
    data,
    `traceability-${safeReportLookup(lookup)}.xlsx`,
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  );
}

export function closeInspectorReportWindow(reportWindow) {
  reportWindow?.close();
}

export function safeReportLookup(lookup) {
  return (
    String(lookup)
      .replace(/[^a-zA-Z0-9._-]+/g, "-")
      .replace(/^[.\-_]+/, "") || "report"
  );
}
